<template>
  <div class="main_contract_manager card" v-if="loaded">
    <div class="content">
      <div class="list_p" v-html="get_word('approve_contract_parts')"></div>
      
      <div class="contract_types_nav">
        <div class="nav_title">פרקי במכרז</div>
        <div class="nav_list">
          <div 
            v-for="type in contract.types" 
            :key="type.id" 
            class="nav_item" 
            :class="{ active: activeTypeId === type.id }"
            @click="selectContractType(type.id)"
          >
            <span class="nav_item_text">{{ type.name }}</span>
          </div>
        </div>
      </div>

      <div class="contract_content">
        <div v-if="activeTypeId && !isLoading" class="contracts_container">
          <approveContractParts 
            v-if="currentContractType"
            ref="contractPartsComponent"
            :bid_step="bid_step" 
            :type="activeTypeId" 
            :state="state" 
            :token="token"
            :contractType="currentContractType"
            @save="handleContractSave"
            :key="activeTypeId"
          />
        </div>
        <div v-else-if="isLoading" class="loading_container">
          <loader />
        </div>
        <div v-else class="empty_state">
          <div class="empty_message">בחר סוג חוזה מהתפריט</div>
        </div>
      </div>

     
    </div>
    <div class="bottom_bar">
      <div class="centered">
      <div class="btn_container" v-if="state === 'edit'">
          <div class="btn next_type" @click="nextType" v-if="hasNextType">לסוג חוזה הבא</div>
          <div class="btn" @click="$emit('next')" v-text="bid_step === 'improve' ? 'סיום ושלח מכרז' : 'המשך לשלב הבא'"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import approveContractParts from './approveContractParts.vue';
import Loader from '../Loader.vue';

export default {
  props: {
    token: {
      type: String,
      required: true,
    },
    bid_step: {
      type: String,
      required: true,
    },
    state: {
      type: String,
      required: false,
      default: 'edit'
    }
  },
  components: { approveContractParts, Loader },
  data() {
    return {
      contract: [],
      activeTypeId: null,
      isLoading: false,
      loaded: false
    }
  },
  async mounted() {
    await this.loadContract();
    this.loaded = true;
    
    if (this.contract.types.length > 0) {
      this.selectContractType(this.contract.types[0].id);
    }
  },
  computed: {
    hasNextType() {
      return this.contract.types.findIndex(type => type.id === this.activeTypeId) + 1 < this.contract.types.length;
    },
    currentContractType() {
      return this.contract.types.find(type => type.id === this.activeTypeId);
    }
  },
  methods: {
    nextType() {
      const nextIndex = this.contract.types.findIndex(type => type.id === this.activeTypeId) + 1;
      if (nextIndex < this.contract.types.length) {
        this.selectContractType(this.contract.types[nextIndex].id);
      }
    },
    async loadContract() {
      try {
        const { data: contract } = await this.api({
          action: 'applying/get_contract_types', 
          data: { token: this.token }
        });
        
        this.contract = contract;
      } catch (error) {
        console.error('Error loading contract types:', error);
      }
    },
    
    selectContractType(typeId) {
      if (this.activeTypeId === typeId) return;
      
    //   this.isLoading = true;
      this.activeTypeId = typeId;
      
    //   // Wait for component to load
    //   this.$nextTick(() => {
    //     setTimeout(() => {
    //       this.isLoading = false;
    //     }, 500);
    //   });
    },
    
    handleContractSave() {
      this.toast('החוזה נשמר בהצלחה');
    }
  }
}
</script>

<style lang="scss" scoped>
.main_contract_manager {
  > .content {
    display: flex;
    flex-direction: column;
    gap: var(--gap_xmid);
    
  
  }
  
  .contract_types_nav {
    background: #f5f7fa;
    border-radius: var(--radius_s);
    padding: var(--gap);
    
    .nav_title {
      font-weight: bold;
      margin-bottom: var(--gap);
    }
    
    .nav_list {
      display: flex;
      flex-wrap: wrap;
      gap: var(--gap);
      
      .nav_item {
        background: white;
        border: 1px solid #e0e6ed;
        border-radius: var(--radius_s);
        padding: var(--gap_small) var(--gap);
        cursor: pointer;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
        
        &:hover {
          border-color: var(--dark_blue);
        }
        
        &.active {
          background: var(--dark_blue);
          color: white;
          border-color: var(--dark_blue);
        }
      }
    }
  }
  
  .contract_content {
    min-height: 400px;
    position: relative;
    
    // Hide the button in the child component since we have it at the parent level
    :deep(.btn_container) {
      display: none;
    }
  }
  
  .loading_container, .empty_state {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 300px;
  }
  
  .empty_message {
    color: #8492a6;
    font-size: 16px;
  }
}
.bottom_bar{

    .btn_container { 
      display: flex; 
      gap: var(--gap);
      align-self: flex-end;
    }
    position: fixed; bottom: 0; left: 0; right: 0; background: #fff; padding: 20px; border-top: 1px solid var(--pageBG);
    .centered{
     
      display: flex; justify-content: flex-end; align-items: center; gap: var(--gap_small);

    }
  }
</style> 